module.exports = __webpack_public_path__ + "static/media/home_bg.ad12d9ce.png";